import { render, staticRenderFns } from "./addPhysicalCommodity.vue?vue&type=template&id=a7876840&scoped=true"
import script from "./addPhysicalCommodity.vue?vue&type=script&lang=js"
export * from "./addPhysicalCommodity.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addPhysicalCommodity.vue?vue&type=style&index=1&id=a7876840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7876840",
  null
  
)

export default component.exports